<template>
  <div style="height: 100%">
    <v-card>
      <v-card-title>Service Calendar</v-card-title>
      <v-card-text>
        <div v-if="!displayedEvents || displayedEvents.length === 0" class="no-events-text">
          (No Events Scheduled)
        </div>
        <v-list two-line>
          <v-list-item v-for="event in displayedEvents" :key="event.identifier">
            <v-list-item-content>
              <v-list-item-title>{{ event.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ formatTimestampToDateTime(event.meetingTime) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <router-link
          v-if="events.length > numberOfEventsToShow"
          :to="{ name: ROUTES.ACCOUNT_CALENDAR }"
          v-text="`See ${events.length - numberOfEventsToShow} more events`"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <router-link :to="{ name: ROUTES.ACCOUNT_CALENDAR }"><v-btn text>Go To Calendar</v-btn></router-link>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import * as routeNames from '@/router/route-names'
import dateHelper from '@/mixins/date-helper'

export default {
  name: 'ServiceCalendarCard',
  mixins: [dateHelper],
  props: {
  },
  created() {
    this.ROUTES = routeNames
    this.numberOfEventsToShow = 2
  },
  computed: {
    events() {
      return this.$store.getters['events/getEvents']
    },
    displayedEvents() {
      if (this.events.length > this.numberOfEventsToShow) {
        return this.events.slice(0, this.numberOfEventsToShow)
      }
      return this.events
    },
  },
}
</script>
<style scoped lang="scss">
.v-card {
  height: 100%;
}

.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
}

.v-card__text {
  padding-bottom: 3rem;
}
.no-events-text {
  color: rgb(0,0,0,0.5);
}
.v-card__actions {
  position: absolute;
  bottom: 0;
  width: 100%;

}
</style>
